type Props = {
  data: { label: string; value: number }[];
  height?: number;
  color?: string;
};

/** 심플한 세로 막대 차트 (외부 라이브러리 없이 SVG로 렌더링) */
export function BarChart({ data, height = 140, color = "#0EA5E9" }: Props) {
  const max = Math.max(1, ...data.map((d) => d.value));

  return (
    <div className="flex items-end gap-2 sm:gap-3" style={{ height }}>
      {data.map((d, i) => {
        const barHeight = Math.max(6, (d.value / max) * (height - 28));
        return (
          <div key={i} className="flex flex-1 flex-col items-center gap-1.5">
            <span className="text-[10px] font-medium text-slate-400">{d.value}</span>
            <div
              className="w-full max-w-[28px] rounded-t-md transition-all"
              style={{
                height: barHeight,
                background: i === data.length - 1 ? color : `${color}55`,
              }}
            />
            <span className="text-[10px] text-slate-400">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}
